import React from 'react';
import { Tab } from '@mui/material';
const CarePlanTab = ({ tabValue, onClick, selectedIndex, hasData }) => {
    let textColor = '';
    let isSelectable = true;
    if (!hasData) {
        textColor = '#00000033';
        isSelectable = false;
    }
    else {
        textColor = '#00000099';
    }
    return (React.createElement("div", { className: 'align-middle' },
        React.createElement(Tab, { id: "Care-Plan", iconPosition: "end", label: "Care Plan", value: tabValue, className: "inline-block padding-text", onClick: () => { if (isSelectable) {
                onClick();
            } }, sx: { fontWeight: 'bold', minHeight: '0px', height: '45px', opacity: '1', color: tabValue === selectedIndex ? '#2C78EB' : textColor } })));
};
export default CarePlanTab;
